import { IMLesson } from '../../types'
import { IM360Parser } from '../IM360Parser'

export function parseStudentLessonSummary({
  student_lesson_summary,
}: IMLesson) {
  if (!student_lesson_summary) return []
  return [
    IM360Parser.getInstance().createActivity(
      {
        title: 'Student Lesson Summary',
        assignment: 'participation',
        assessment_grading: 'formative',
      },
      [
        IM360Parser.getInstance().createNoteNode({
          title: 'Student Lesson Summary',
          value: student_lesson_summary,
          studentFacing: true,
        }),
      ],
    ),
  ]
}
